export default __webpack_public_path__ + "static/media/pitikUnderThree.8a4d615c.png";